import { render, staticRenderFns } from "./Dowjones.vue?vue&type=template&id=006809aa&"
import script from "./Dowjones.vue?vue&type=script&lang=js&"
export * from "./Dowjones.vue?vue&type=script&lang=js&"
import style0 from "./Dowjones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports